
export default {
	methods: {
		/**
		 * Toast表示
		 */
		async $_buefyMixin_showToast (message, duration, type, queue) {
			if (!message) {
				// eslint-disable-next-line
				console.error('Toastのメッセージ指定がありません')
				return
			}

			const options = {}
			options.message = message
			options.duration = duration || 5 * 1000
			options.type = type || 'is-dark'
			options.queue = queue || true
			return this.$buefy.toast.open(options)
		}
	}
}
